import { ResponsiveActionButton } from 'components/Buttons'

const LihatDetail = ({ id, onClick, testId = 'lihat-detail', ...props }) => {
  return (
    <div className="pointer" data-testid={testId} {...props}>
      <ResponsiveActionButton
        iconName="eye"
        label="Lihat Detail"
        onClick={onClick}
        testId={testId}
      />
    </div>
  )
}

export default LihatDetail
